import { createDataFetchSlice } from '../../../utils/dataFetch';


export const adminReportsPaymentDetailsExcelSlice = createDataFetchSlice<
    string
>({ name: 'paymentDetailsExcel' });
